<template>
  <div class="geolocation-guide-mask">
    <div class="geolocation-guide-container">
      <div class="guide-header">
        <span class="guide-icon">{{ guide.icon }}</span>
        <h3>{{ guide.title }}</h3>
      </div>

      <div class="guide-content">
        <p class="guide-intro">
          您已拒絕定位權限，無法自動顯示附近店家。
          請依照以下步驟重新開啟定位權限：
        </p>

        <ol class="guide-steps">
          <li v-for="(step, index) in guide.steps" :key="index">
            {{ step }}
          </li>
        </ol>

        <div class="guide-actions">
          <button class="btn-retry" @click="handleRetry" :disabled="isRetrying">
            <span v-if="isRetrying">🔄 定位中...</span>
            <span v-else>🔄 我已開啟權限，重新定位</span>
          </button>
          <button class="btn-dismiss" @click="handleDismiss">
            知道了
          </button>
        </div>

        <p class="guide-alternative">
          或者，您也可以使用
          <a href="#" @click.prevent="$emit('use-manual-selection')">
            手動選擇縣市/行政區
          </a>
          來篩選店家。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import geolocationMixin from '@/mixins/geolocationMixin';

export default {
  name: 'GeolocationGuide',

  mixins: [geolocationMixin],

  data() {
    return {
      guide: {},
      isRetrying: false
    };
  },

  created() {
    // 在元件建立時取得瀏覽器對應的指引
    this.guide = this.getGeolocationGuide();
  },

  methods: {
    /**
     * 使用者點擊「重新定位」按鈕
     * 清除快取並重新請求定位
     */
    async handleRetry() {
      this.isRetrying = true;

      try {
        // 清除舊的拒絕狀態
        this.clearGeolocationCache();

        // 關閉指引對話框
        this.$emit('close');

        // 重新請求定位（force = true, isManualRetry = true）
        await this.autoGeolocation(true, true);

        // 通知父元件重試成功
        this.$emit('retry-success');

      } catch (error) {
        console.error('Retry geolocation failed:', error);

        // 如果再次失敗，通知父元件
        this.$emit('retry-failed', error);

      } finally {
        this.isRetrying = false;
      }
    },

    /**
     * 使用者點擊「知道了」按鈕
     * 關閉指引，保持顯示縣市選單
     */
    handleDismiss() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.geolocation-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.geolocation-guide-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
  max-height: 90vh;
  overflow-y: auto;
}

.guide-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.guide-icon {
  font-size: 32px;
}

.guide-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.guide-content {
  color: #444;
}

.guide-intro {
  margin: 0 0 16px;
  line-height: 1.5;
}

.guide-steps {
  margin: 16px 0;
  padding-left: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px 16px 16px 40px;
  border: 1px solid #eee;
}

.guide-steps li {
  margin: 8px 0;
  line-height: 1.5;
}

.guide-actions {
  display: flex;
  gap: 12px;
  margin: 20px 0;
}

button {
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-retry {
  background: #28a745;
  color: white;
  flex: 2;
}

.btn-retry:hover:not(:disabled) {
  background: #218838;
}

.btn-dismiss {
  background: #6c757d;
  color: white;
  flex: 1;
}

.btn-dismiss:hover {
  background: #5a6268;
}

.guide-alternative {
  margin: 16px 0 0;
  font-size: 14px;
  text-align: center;
  color: #666;
}

.guide-alternative a {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

/* 行動裝置適配 */
@media (max-width: 600px) {
  .geolocation-guide-mask {
    padding: 15px;
    align-items: center; /* 行動版也可保持置中或改為底部彈出 */
  }

  .geolocation-guide-container {
    padding: 20px;
  }

  .guide-actions {
    flex-direction: column;
  }

  button {
    width: 100%;
  }
}
</style>
